import React, { useEffect, useRef, useState } from 'react';
import { HOLES, DISTANCES, MAP_ASSETS, VIEWBOX } from './courseData';
import HolePath from './HolePath';

const CourseMap = ({ hole, tee, view, reduced, onSelectHole, onHoleEnd }) => {
  const wrapRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [loaded, setLoaded] = useState({ plan: false, aerial: false });

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return undefined;
    const ro = new ResizeObserver(([entry]) => {
      const w = entry.contentRect.width || 1;
      setScale(Math.min(2.2, Math.max(1, 720 / w)));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      className="relative rounded-xl overflow-hidden lg:self-start"
      style={{ boxShadow: '0 20px 60px -15px rgba(201, 169, 98, 0.2), 0 0 0 1px rgba(201, 169, 98, 0.2)' }}
      data-testid="masterplan-map"
    >
      <div ref={wrapRef} className="relative bg-[#0f2419]" style={{ aspectRatio: '879.2 / 560' }}>
        <img
          src={MAP_ASSETS.plan}
          alt="Master plan du Golf de Songon M'braté"
          className="absolute inset-0 w-full h-full"
          style={{ objectFit: 'fill', opacity: loaded.plan ? 1 : 0, transition: 'opacity .8s ease' }}
          onLoad={() => setLoaded((l) => ({ ...l, plan: true }))}
          data-testid="map-image-plan"
        />
        <img
          src={MAP_ASSETS.aerial}
          alt="Vue aérienne du domaine"
          loading="lazy"
          className="absolute inset-0 w-full h-full"
          style={{ objectFit: 'fill', opacity: view === 'aerial' && loaded.aerial ? 1 : 0, transition: 'opacity .7s ease' }}
          onLoad={() => setLoaded((l) => ({ ...l, aerial: true }))}
          data-testid="map-image-aerial"
        />
        {!loaded.plan && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-10 h-10 border-2 border-[#c9a962]/30 border-t-[#c9a962] rounded-full animate-spin" />
          </div>
        )}
        <svg viewBox={VIEWBOX} className="absolute inset-0 w-full h-full" aria-label="Tracés des 9 trous" role="group">
          {HOLES.map((h) => (
            <HolePath
              key={h.number}
              hole={h}
              active={hole === h.number}
              dimmed={hole !== null && hole !== h.number}
              tee={tee}
              distance={DISTANCES[tee][h.number - 1]}
              view={view}
              scale={scale}
              reduced={reduced}
              onSelect={onSelectHole}
              onEnd={onHoleEnd}
            />
          ))}
        </svg>
        <div className="absolute inset-0 pointer-events-none" style={{ boxShadow: 'inset 0 0 80px rgba(15,36,25,0.25)' }} />
      </div>
    </div>
  );
};

export default CourseMap;
